// Pre-compiled regex patterns for better performance
// These are created once and reused throughout the application

// Stock symbol highlighting regex
// Matches both $SYMBOL and @SYMBOL where SYMBOL is 1-5 uppercase letters
// Supports suffixes with dots or hyphens (e.g., BRK.B, RDS-A)
// Negative lookbehind to avoid matching symbols already in links
export const STOCK_SYMBOL_REGEX = /(?<!\[)([\$@])([A-Z]{1,5}(?:[.-][A-Z0-9]{1,3})?)(?!\w)/g;

// Collection parsing regex
// Matches collection references in text
export const COLLECTION_REFERENCE_REGEX = /\[Collection:([^\]]+)\]/g;

// Citation replacement regex
// Matches citation patterns like [1], [2], etc.
export const CITATION_REGEX = /\[(\d+)\]/g;

// URL validation regex
export const URL_REGEX = /^https?:\/\/[^\s]+$/;

// Email validation regex
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Symbol validation regex (for input validation)
export const SYMBOL_VALIDATION_REGEX = /^[A-Z]{1,5}$/;

// Utility functions for common regex operations
export const transformStockSymbols = (content: string): string => {
  return content.replace(STOCK_SYMBOL_REGEX, (_match, prefix, symbol) => {
    return `[${prefix}${symbol}](/symbol/${encodeURIComponent(symbol)})`;
  });
};

export const replaceCitations = (content: string, citations: string[]): string => {
  return content.replace(CITATION_REGEX, (match, refNumber) => {
    const index = parseInt(refNumber, 10) - 1;
    const citation = citations[index];
    return citation ? `\[[${refNumber}](${citation})\]` : match;
  });
};

export const parseCollections = (content: string): string[] => {
  const matches = content.match(COLLECTION_REFERENCE_REGEX);
  return matches ? matches.map((match) => match.replace(/\[Collection:([^\]]+)\]/, '$1')) : [];
};

export const isValidSymbol = (symbol: string): boolean => {
  return SYMBOL_VALIDATION_REGEX.test(symbol);
};

export const isValidUrl = (url: string): boolean => {
  return URL_REGEX.test(url);
};

export const isValidEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email);
};
